import { put, select } from "redux-saga/effects";
import {
  ConnectionResultEnum,
  InvalidEnum,
  PaymentSessionToken,
} from "redmond";
import { getIsTravelApp, getUserDeviceData } from "@capone/common";
import { actions } from "../../actions";
import schedulePayment from "../../../../api/v0/book/book-flow/schedulePayment";
import { ProductFunnelHeader } from "../../../../api/v0/book/book-flow/productFunnel";
import { getSession, getVacationRentalsOpaquePayments, getTripDescription } from "../../reducer";
import { IStoreState } from "../../../../reducers/types";

export function* scheduleVacationRentalsBookSaga({
  agentFee,
  isRecommended,
  initialTime,
}: actions.IScheduleVacationRentalsBook) {
  try {
    const state: IStoreState = yield select();
    const session = getSession(state);
    if (!session) {
      throw Error("Session is undefined");
    }
    const payments = getVacationRentalsOpaquePayments(state);
    if (!payments) {
      throw new Error("Invalid Request.");
    }

    const corporateOutOfPolicyReason =
      state.premierCollectionBook.approvalRequestReason;
    const corporateTripDescription = getTripDescription(state);

    const { isTravelApp } = getIsTravelApp();

    const userDeviceData = getUserDeviceData();

    const channel = (() => {
      switch (true) {
        case isTravelApp:
          return "TravelApp";
        case userDeviceData.deviceType === "mobile":
          return "Mobile";
        default:
          return "Web";
      }
    })();
    const result: string = yield schedulePayment(
      session,
      payments,
      undefined,
      channel,
      corporateOutOfPolicyReason,
      corporateTripDescription,
      ProductFunnelHeader.VacationRentals
    );

    // update the session to the fulfill session token
    yield put(actions.setSession({ value: result } as PaymentSessionToken));
    yield put(
      actions.pollVacationRentalsConfirmationDetails(
        session!,
        agentFee,
        isRecommended,
        initialTime
      )
    );
    yield put(actions.setScheduleVacationRentalsBookSuccess());
  } catch (e) {
    yield put(
      actions.setScheduleVacationRentalsBookFailed({
        Invalid: InvalidEnum.Missing,
        ConnectionResult: ConnectionResultEnum.Invalid,
      })
    );
  }
}
